angular.module('admin')
  .config(['$stateProvider', 'APP_CONFIG', function($stateProvider, APP_CONFIG){

    const authenticated = ['SessionService', '$q', 'AuthResolver', function(SessionService, $q, AuthResolver){
      if(SessionService.isLoggedIn())
        return AuthResolver.identifyUser();
      else
        return $q.reject();
    }];


    $stateProvider.state('agent', {
      abstract: true,
      url: '/agent/:id',
      templateUrl: '/admin/templates/pages/agent.html',
      // note: this doesn't need auth since it's abstract;
      // the default route under it auth's for it
    });

    $stateProvider.state('agent.stream', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/activity',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients', {
      url: '/clients',
      controller: 'AgentClientListCtrl',
      templateUrl: '/admin/templates/pages/agent-all-clients.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.page', {
      url: '/page/:page',
      controller: 'AgentClientListCtrl',
      templateUrl: '/admin/templates/pages/agent-all-clients.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.unsent', {
      url: '/unsent',
      controller: 'AgentClientListCtrl',
      templateUrl: '/admin/templates/pages/agent-all-clients.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.needsCMA', {
      url: '/needs-cma',
      controller: 'AgentClientListCtrl',
      templateUrl: '/admin/templates/pages/agent-all-clients.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.sharedClients', {
      url: '/shared-clients',
      controller: 'AgentClientListCtrl',
      templateUrl: '/admin/templates/pages/agent-all-clients.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.invited', {
      url: '/invited',
      controller: 'AgentClientListCtrl',
      templateUrl: '/admin/templates/pages/agent-all-clients.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.newClients', {
      abstract: true,
      url: '/new-clients',
      templateUrl: '/admin/templates/pages/agent-new-clients.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.newClients.addOne', {
      url: '',
      controller: 'AgentNewClientCtrl',
      templateUrl: '/admin/templates/pages/agent-new-client.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.newClients.import', {
      url: '/import',
      controller: 'AgentImportClientsCtrl',
      templateUrl: '/admin/templates/pages/agent-import.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.sponsors', {
      url: '/sponsors',
      controller: 'AgentSponsorsCtrl',
      templateUrl: '/admin/templates/pages/agent-sponsors.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.realEstateAgents', {
      url: '/real-estate-agents',
      controller: 'AgentRealEstateAgentsCtrl',
      templateUrl: '/admin/templates/pages/agent-real-estate-agents.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.realEstateAgents.sponsoredAgent', {
      url: '/sponsored-agent/:sponsoredAgentId',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.realEstateAgents.detail', {
      url: '/detail/:mlsset',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.homeDetail', {
      url: '/home-detail/:homeId?clientId',
      controller: 'AgentHomeDetailCtrl',
      templateUrl: '/admin/templates/pages/agent-home-detail.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.adminGroups', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/company/{groupId}/users',
      external: true,
      params: {
        groupId: null,
      },
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.edit', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/profile',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.new-features', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/profile/new-features',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.client-issues', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/issues',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.client-leads', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/leads',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.billing-info', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/profile/billing-info',
      external: true,
      resolve: {
        authenticated: authenticated
      }
    });

    $stateProvider.state('agent.agents', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/agents',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.buyers', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/buyers',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.activity', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/activity',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.homeowners', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/homeowners',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.homeowners.needsCMA', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/homeowners/needs-cma',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.homeowners.leads', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/homeowners/leads',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.clients.new', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/new',
      external: true,
      resolve: {
        authenticated: authenticated
      }
    });

    $stateProvider.state('agent.customize', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/customize/power-ups',
      external: true,
      resolve: {
        authenticated: authenticated
      }
    });

    $stateProvider.state('agent.sponsor', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/sponsor',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.homePreview', {
      externalUrl: APP_CONFIG.CLIENTS_FRONTEND_URL + '/reports/home/{homeId}?cct=true',
      external: true,
      params: {
        homeId: null,
      },
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.homePreviewForClientRefi', {
      externalUrl: APP_CONFIG.CLIENTS_FRONTEND_URL + '/reports/{clientId}/home/{homeId}?cct=true#RefiSection',
      external: true,
      params: {
        homeId: null,
        clientId: null,
      },
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.billing', {
      url: '/billing',
      controller: 'AgentBillingCtrl',
      data: {
        pageTitle: 'Billing Information',
        back: 'agent.clients',
      },
      templateUrl: '/admin/templates/pages/agent-billing.html',
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.share', {
      externalUrl: APP_CONFIG.MAINSTREET_URL + '/share',
      external: true,
      resolve: {
        authenticated: authenticated,
      },
    });

    $stateProvider.state('agent.onboarding', {
      external: true,
      externalUrl: APP_CONFIG.MAINSTREET_URL,
    });

  }]);
